exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-number[data-v-dd7f673a]{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;font-size:1.15em}.card-number .number-partial[data-v-dd7f673a]:not(:last-child){margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dd7f673a","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/CardNumber.vue
// module id = 786
// module chunks = 0